import { useIntl } from 'react-intl'
import _get from 'lodash/get';
import Card from '@/entities/Card';
import { PayoutsChart } from '~/accountingAndAnonymous/Payouts';

type PayoutsChartWidgetProps = {
  className: string;
}

const PayoutsChartWidget = (props: PayoutsChartWidgetProps) => {
  const { className } = props;
  const intl = useIntl();

  return (
    <Card 
      className={className} 
      title={intl.formatMessage({ id: 'payouts' })}
    >
      <PayoutsChart/>
    </Card>
  );
}

export default PayoutsChartWidget;
